import {
  ActionArm,
  ActionDisarm,
  ActionElevate,
  ActionGoto,
  ActionInspection,
  ActionQLand,
  ActionStickControl,
  ActionTakeoff,
  CameraGimbal,
  CameraLiveView,
  CameraShoot,
  MissionClear,
  MissionLoad,
  MissionResume,
  MissionStart,
  MissionUpload,
  ModeAuto,
  ModeLoiter,
  ModeQRTL,
  ModeRTL,
} from '@/define/commandSet/mavlink';

const commandGroups = [
  {
    name: 'Mode',
    commands: [ModeAuto, ModeLoiter, ModeRTL, ModeQRTL],
  },
  {
    name: 'Action',
    commands: [
      ActionInspection,
      ActionArm,
      ActionDisarm,
      ActionTakeoff,
      ActionGoto,
      ActionElevate,
      ActionQLand,
      ActionStickControl,
    ],
  },
  {
    name: 'Camera',
    commands: [CameraLiveView, CameraGimbal, CameraShoot],
  },
  {
    name: 'Mission',
    commands: [MissionLoad, MissionUpload, MissionStart, MissionResume, MissionClear],
  },
];

export default commandGroups;
